import React from "react";
import { Card, Button, Row, Col } from "antd";
import { BankOutlined, WalletOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDashboard } from "../../store/context/DashboardContext";

const DashboardCards = () => {
  const navigate = useNavigate();
  const { bankingProfile } = useDashboard();
  // Profile-only customers (no core banking account) can't act on these CTAs yet.
  const requiresAccount = bankingProfile?.hasCoreBankingAccounts === false;
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} xl={12} xxl={24}>
        {" "}
        {/* First Card - Open Account */}
        <Card
          className="shadow-md w-full border= border-gray-300 rounded-lg px-3 py-6 text-center flex flex-col items-center"
          style={{ background: "transparent" }}
        >
          <BankOutlined style={{ fontSize: "4rem", color: "#e5791b" }} />
          <h5 className="mt-4 text-lg font-semibold">
            Open a New Account Today
          </h5>
          <p className="mt-2 text-sm text-gray-600">
            Join our banking platform and manage your finances with ease.
          </p>
          <Button
            type="primary"
            disabled={requiresAccount}
            className="mt-4 bg-[#e5791b] border-none text-white"
            onClick={() => alert("Navigating to account creation...")}
          >
            Create Account
          </Button>
        </Card>
      </Col>
      <Col xs={24} xl={12} xxl={24}>
        {/* Second Card - Savings & Interest */}
        <Card
          className="flex flex-col items-center w-full px-3 py-6 text-center border border-gray-300 rounded-lg shadow-md"
          style={{ background: "transparent" }}
        >
          <WalletOutlined style={{ fontSize: "4rem", color: "#007bff" }} />
          <h5 className="mt-4 text-lg font-semibold">
            Start Saving & Earn <span className="text-blue-500">10%</span>{" "}
            Interest
          </h5>
          <p className="mt-2 text-sm text-gray-600">
            Save smarter with our flexible plans and grow your money
            effortlessly.
          </p>
          <Button
            type="primary"
            disabled={requiresAccount}
            className="mt-4 bg-[#007bff] border-none text-white"
            onClick={() => navigate("/my-savings")}
          >
            Discover More
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default DashboardCards;
